import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareInfo"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H3ZM10 10.25H12.75L12.75 17L11.25 17L11.25 11.75H10V10.25ZM12.75 7.25H11.25V8.75H12.75V7.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareInfo;
